module.exports = __webpack_public_path__ + "img/Q1.c95ed1d3.jpg";